function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M596.527 50.0481H504.078C479.683 21.8727 443.731 4 403.669 4H270.719C230.657 4 194.705 21.8727 170.31 50.0481H77.8608C37.1339 50.0481 4 83.2477 4 124.053V770.366C4 811.172 37.1339 844.371 77.8608 844.371H596.527C637.254 844.371 670.388 811.172 670.388 770.366V124.053C670.388 83.246 637.254 50.0481 596.527 50.0481ZM270.719 53.3373H403.669C441.71 53.3373 473.303 78.8029 483.685 112.541H190.704C201.067 78.862 232.619 53.3373 270.719 53.3373ZM621.148 770.366C621.148 783.968 610.103 795.034 596.527 795.034H77.8608C64.2851 795.034 53.2405 783.968 53.2405 770.366V124.053C53.2405 110.451 64.2851 99.3854 77.8608 99.3854H143.262C139.708 111.384 137.77 124.071 137.77 137.21C137.77 150.834 148.793 161.878 162.39 161.878H511.998C525.595 161.878 536.618 150.834 536.618 137.21C536.618 124.071 534.68 111.384 531.126 99.3854H596.527C610.103 99.3854 621.148 110.451 621.148 124.053V770.366Z",
  fill: "#FFA724",
  stroke: "#FFA724",
  strokeWidth: 6.46439
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M215.834 494.179L179.625 530.456L170.772 521.586C161.159 511.951 145.569 511.951 135.954 521.586C126.339 531.219 126.339 546.838 135.954 556.471L162.216 582.784C171.829 592.417 187.418 592.418 197.034 582.784L250.65 529.062C260.265 519.429 260.265 503.81 250.65 494.177C241.036 484.544 225.447 484.544 215.834 494.179Z",
  fill: "#FFA724",
  stroke: "#FFA724",
  strokeWidth: 6.46439
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M519.384 513.81H320.781C307.184 513.81 296.161 524.855 296.161 538.478C296.161 552.101 307.184 563.146 320.781 563.146H519.384C532.981 563.146 544.004 552.101 544.004 538.478C544.004 524.855 532.981 513.81 519.384 513.81Z",
  fill: "#FFA724",
  stroke: "#FFA724",
  strokeWidth: 6.46439
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M215.834 635.621L179.625 671.898L170.772 663.028C161.159 653.393 145.569 653.393 135.954 663.028C126.339 672.661 126.339 688.28 135.954 697.913L162.216 724.226C171.829 733.859 187.418 733.86 197.034 724.226L250.65 670.504C260.265 660.871 260.265 645.252 250.65 635.619C241.036 625.986 225.447 625.986 215.834 635.621Z",
  fill: "#FFA724",
  stroke: "#FFA724",
  strokeWidth: 6.46439
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M519.384 655.238H320.781C307.184 655.238 296.161 666.282 296.161 679.906C296.161 693.529 307.184 704.574 320.781 704.574H519.384C532.981 704.574 544.004 693.529 544.004 679.906C544.004 666.282 532.981 655.238 519.384 655.238Z",
  fill: "#FFA724",
  stroke: "#FFA724",
  strokeWidth: 6.46439
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M384.148 399.689L460.296 323.392V326.332C460.296 339.955 471.32 351 484.917 351C498.514 351 509.537 339.955 509.537 326.332C509.537 256.553 509.652 263.05 509.255 260.294C507.513 248.225 497.186 239.166 484.908 239.17H422.545C408.948 239.17 397.925 250.214 397.925 263.838C397.925 277.461 408.948 288.505 422.545 288.505H425.478L366.739 347.359L292.232 272.707C282.619 263.073 267.029 263.073 257.414 272.707L168.781 361.514C159.166 371.147 159.166 386.766 168.781 396.4C178.394 406.034 193.984 406.034 203.599 396.4L274.824 325.037L349.331 399.689C358.943 409.322 374.534 409.324 384.148 399.689Z",
  fill: "#FFA724",
  stroke: "#FFA724",
  strokeWidth: 6.46439
});

const SvgCommissionReportIcon = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 674,
    height: 848,
    viewBox: "0 0 674 848",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCommissionReportIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/commission-report-icon.9cd384a7.svg";
export { ForwardRef as ReactComponent };